import { QuickFeedbackResponse } from './types';

export const mockFeedbackResponse = {
  bar: {
    categories: null,
    values: [
      {
        category: 'Positive',
        extended_label: null,
        extended_labels: [],
        label: 'Positive',
        tooltip_values: null,
        type: 'number',
        value: 57,
      },
      {
        category: 'Negative',
        extended_label: null,
        extended_labels: [],
        label: 'Negative',
        tooltip_values: null,
        type: 'number',
        value: 76,
      },
      {
        category: 'Not answered',
        extended_label: null,
        extended_labels: [],
        label: 'Not answered',
        tooltip_values: null,
        type: 'number',
        value: 19720,
      },
    ],
  },
  donut: {
    values: [
      {
        extended_label: null,
        extended_labels: [],
        label: 'positive',
        type: 'percentage',
        value: 0.0,
      },
      {
        extended_label: null,
        extended_labels: [],
        label: 'negative',
        type: 'percentage',
        value: 0.0,
      },
      {
        extended_label: null,
        extended_labels: [],
        label: 'not answered',
        type: 'percentage',
        value: 0.99,
      },
    ],
  },
  misc: {
    delta_total_response: null,
    delta_value: null,
    negative: 76,
    negative_label: 'Negative',
    not_answered: 19720,
    not_answered_label: 'Not answered',
    positive: 57,
    positive_label: 'Positive',
    title: 'Quick feedback',
    total_response: 19853,
  },
  type: 'insights_feedback',
};

export const mockInteractedResponse = {
  bar: null,
  donut: null,
  misc: {
    delta_value: null,
    no: 1500,
    title: 'Interacted with Assist AI',
    yes: 6700,
  },
  type: 'insights_articles_performance',
};

export const mockGeneratedReplyResponse = {
  bar: null,
  donut: null,
  misc: {
    delta_value: null,
    generated: 9000,
    title: 'Generated reply',
    unused: 3800,
    used: 5200,
  },
  type: 'insights_articles_performance',
};

export const mockConversationResponse = {
  bar: null,
  donut: null,
  misc: {
    delta_value: null,
    helpful: 8000,
    title: 'Conversations',
    total: 10000,
    unhelpful: 2000,
  },
  type: 'insights_articles_performance',
};
export const mockQuickFeedbackResponse: QuickFeedbackResponse = {
  bar: {
    categories: ['Positive', 'Negative', 'Not answered'],
    values: [
      {
        category: 'Positive',
        extended_label: null,
        label: 'Positive',
        tooltip_values: undefined,
        type: 'number',
        value: 36,
      },
      {
        category: 'Negative',
        extended_label: null,
        label: 'Negative',
        tooltip_values: undefined,
        type: 'number',
        value: 109,
      },
      {
        category: 'Not answered',
        extended_label: null,
        label: 'Not answered',
        tooltip_values: undefined,
        type: 'number',
        value: 2244,
      },
    ],
  },
  donut: {
    values: [
      {
        extended_label: null,
        label: 'positive',
        type: 'percentage',
        value: 0.015,
      },
      {
        extended_label: null,
        label: 'negative',
        type: 'percentage',
        value: 0.046,
      },
      {
        extended_label: null,
        label: 'not answered',
        type: 'percentage',
        value: 0.939,
      },
    ],
  },
  misc: {
    delta_value: undefined,
    negative: 109,
    not_answered: 2244,
    positive: 36,
    title: 'Agent quick feedback',
  },
  type: 'insights_articles_performance',
};
